export const OPENAI_LIVE_BOOTSTRAP_HOLD_SECONDS = 5 * 60;
export const MIN_WS_HOLD_USD = 0.01;

export function isOpenAiLiveEndpoint(endpoint) {
  return endpoint?._raw?.wsConfig?.adapter === 'openai-live';
}

export function resolveOpenAiLiveBootstrapHoldUsd(wsConfig, wsBilling) {
  const rawDuration = wsConfig?.maxDurationSec;
  const configuredDuration = rawDuration == null ? Number.NaN : Number(rawDuration);
  const maxDurationSec = Number.isFinite(configuredDuration)
    ? Math.max(0, configuredDuration)
    : OPENAI_LIVE_BOOTSTRAP_HOLD_SECONDS;
  const rate = Math.max(0, Number(wsBilling?.perMinuteUsd) || 0);
  const hold =
    (Math.min(maxDurationSec, OPENAI_LIVE_BOOTSTRAP_HOLD_SECONDS) / 60) *
    rate;
  const rounded = Math.round(hold * 1e8) / 1e8;
  return rounded > 0 ? rounded : MIN_WS_HOLD_USD;
}

const authorizationAmount = (value) => {
  if (value == null || value === '') return null;
  const amount = Number(value);
  return Number.isFinite(amount) && amount >= 0 ? amount : null;
};

export function resolveOpenAiLiveAuthorizationDisplay(endpoint) {
  const raw = endpoint?._raw || {};
  const published = raw.wsAuthorization || {};
  return {
    initialAuthorizationUsd:
      authorizationAmount(published.initialAuthorizationUsd) ??
      resolveOpenAiLiveBootstrapHoldUsd(raw.wsConfig, raw.wsBilling),
    officialStartAuthorizationUsd: authorizationAmount(
      published.officialStartAuthorizationUsd,
    ),
    maxSessionAuthorizationUsd: authorizationAmount(
      published.maxSessionAuthorizationUsd,
    ),
  };
}

export function openAiLiveDelegationPricingRows(wsBilling) {
  const input = wsBilling?.delegationInputTokenUsd;
  return [
    { key: 'input', label: 'Input', value: input },
    {
      key: 'cache-write',
      label: 'Cache write',
      value: wsBilling?.delegationCacheWriteTokenUsd ?? input,
    },
    {
      key: 'cached-input',
      label: 'Cached input',
      value: wsBilling?.delegationCachedInputTokenUsd ?? input,
    },
    {
      key: 'output',
      label: 'Output',
      value: wsBilling?.delegationOutputTokenUsd,
    },
  ].filter((row) => Number.isFinite(Number(row.value)) && Number(row.value) >= 0);
}
